export default [
  {
    nome: 'Paulo Roberto',
    image: require('../../../images/quem_somos/funcionarios/paulo.jpg'),
    linkedin: 'https://www.linkedin.com/in/paulo-roberto-289903120/'
  },
  {
    nome: 'Lucas Silva',
    image: require('../../../images/quem_somos/funcionarios/lucas.jpg'),
    linkedin: 'https://www.linkedin.com/in/lucas-alves-da-silva-829805101/'
  },
  {
    nome: 'Roberto Gonçalves',
    image: require('../../../images/quem_somos/funcionarios/Roberto.jpg'),
    linkedin: 'https://www.linkedin.com/in/robertogsilva/'
  },
  {
    nome: 'Thiago Henrique',
    image: require('../../../images/quem_somos/funcionarios/thiago.jpg'),
    linkedin: 'https://www.linkedin.com/in/thiago-henrique-48024a11a/'
  },
  {
    nome: 'Thiago dos Santos',
    image: require('../../../images/quem_somos/funcionarios/thiago_dos_santos.jpg'),
    linkedin: ''
  },
  {
    nome: 'Warley Alcântara',
    image: require('../../../images/quem_somos/funcionarios/warley.jpeg'),
    linkedin: ''
  },
  {
    nome: 'Warley Alcântara',
    image: require('../../../images/quem_somos/funcionarios/warley.jpeg'),
    linkedin: ''
  },
  {
    nome: 'Warley Alcântara',
    image: require('../../../images/quem_somos/funcionarios/warley.jpeg'),
    linkedin: ''
  },
  {
    nome: 'Warley Alcântara',
    image: require('../../../images/quem_somos/funcionarios/warley.jpeg'),
    linkedin: ''
  },
]